
export default {

	// dog
	old: [
		'щенки',
		'взрослые',
		'от 6 лет и выше',
	],
	body: [
		'атлетичное',
		'рыхлое',
		'склонное к полноте',
	],
	size: [
		'миниатюрный',
		'мелкий',
		'средний',
		'крупный',
	],


	// man
	gender: [
		'мужской',
		'женский',
	],
	age: [
		'18-24',
		'25-30',
		'30+',
	],
	place: [
		'парк',
		'собачья площадка',
		'центр города',
		'набережная',
	],
	time: [
		'до 20 мин.',
		'20-40 мин.',
		'40 мин. и более',
	],


	city: [
		'екатеринбург',
		'новосибирск',
		'москва',
		'Санкт-Петербург',
	],
}



// WEBPACK FOOTER //
// ./src/data/options.js